module.exports = __webpack_public_path__ + "img/icon_map_wrzb_c.e0a94a23.png";